import { faEye } from '@fortawesome/pro-regular-svg-icons';

import { FAIcon } from './fa-icon';

export const EyeIcon = ({ width }: { width?: string }) => (
  <FAIcon icon={faEye} width={width} />
);
